import { HorariolaboralRegimen } from 'components/UsuarioGeneral/Permisos/Solicitud Permisos/TypesSolicitudesPermisos';
import { EmpleadoHorario } from 'components/UsuarioGeneral/Solicitud Cambio Horario/TypesCambioHorarioPRN';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Button, Col, Row, Alert, Spinner } from 'reactstrap';

import add from 'date-fns/add'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { SumarDiasFecha, formatDateToString, toHoursAndMinutes } from 'functions/DatesFunctions';
import Datepicker2 from '../DatepickerNew';
import { isFeriado, isFeriadoFilter, isWeekday } from 'functions/CalendarFunctions';
import SelectItem2 from '../SelectNew';
import configData from "./../../../config.json";

const API_URL = configData.SERVER_URL

export type PropsModalRegistrarInfante = {
    isOpenRegistrarInfante: boolean;
    toggleRegistrarInfante: () => void;
    // Eliminamos onSaveRegistrarInfante ya que no lo necesitaremos
    onClose?: () => void; // Opcional: para notificar al padre que el modal fue cerrado
    subtipoMaternidad: string;
}

export const tiposIdentificacion = [
    { label: 'Cédula', value: "CED" },
    { label: 'Pasaporte', value: "PAS" },
];

export default function ModalRegistrarInfante(props: PropsModalRegistrarInfante) {
    const { isOpenRegistrarInfante, toggleRegistrarInfante, onClose, subtipoMaternidad } = props;

    const [tipoidentificacion, setTipoIdentificacion] = useState("");
    const [numeroidentificacion, setNumeroIdentificacion] = useState("");
    const [nombres, setNombres] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState("");
    const [sexo, setSexo] = useState("");
    const [parentesco, setParentesco] = useState("");
    const [usoGuarderia, setUsoGuarderia] = useState("");

    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [isLoadingData, setIsLoadingData] = useState(false); // Nuevo estado para carga de datos
    const [registrosRealizados, setRegistrosRealizados] = useState(0);

    // Función para limpiar los datos del infante
    const limpiarDatosInfante = () => {
        setNombres("");
        setApellidos("");
        setFechaNacimiento("");
        setSexo("");
        setParentesco("");
        setError("");
    };

    // Función para limpiar todo el formulario
    const limpiarFormulario = () => {
        setTipoIdentificacion("");
        setNumeroIdentificacion("");
        limpiarDatosInfante();
        setUsoGuarderia("");
    };

    // Manejar cambio de tipo de identificación
    const handleTipoIdentificacionChange = (value: string) => {
        setTipoIdentificacion(value);
        setNumeroIdentificacion(""); // Limpiar número al cambiar tipo
        limpiarDatosInfante(); // Limpiar datos del infante
    };

    function getNombresCompletos(nombre_padre, nombre_madre, nombre: string) {
        var nombres = "";
        var apellido_padre = "";
        var apellido_madre = "";

        var padre_list: string[] = nombre_padre.trim().split(' ');
        var madre_list: string[] = nombre_madre.trim().split(' ');
        var nombres_list = nombre.trim().split(' ');

        //var herencia_padre_tmp = padre_list.map(i => i.toString()).intersect(nombres_list);
        //var herencia_madre_tmp = madre_list.map(i => i.toString()).intersect(nombres_list);

        var herencia_padre_tmp = padre_list.filter(x => nombres_list.includes(x.toString()));
        var herencia_madre_tmp = madre_list.filter(x => nombres_list.includes(x.toString()));

        var herencia_padre_array = herencia_padre_tmp;
        var herencia_madre_array = herencia_madre_tmp;

        if (herencia_padre_tmp.length === 0 && herencia_madre_tmp.length > 0) {
            const indiceApellidoMadre = nombre.indexOf(herencia_madre_tmp[0]);
            padre_list = nombre.slice(0, indiceApellidoMadre).trim().split(' ');
            herencia_padre_array = padre_list;

            if (herencia_padre_array.length > 0 && herencia_padre_array[0] === "") {
                const division_nombres: string[] = nombre.split(" ");
                var nombres_input: string = ""
                var apellido: string
                var apellido2: string

                if (division_nombres.length === 4) {
                    division_nombres.slice(2, undefined).forEach(n => {
                        nombres_input += n + " ";
                    });
                    apellido = division_nombres[0];
                    apellido2 = division_nombres[1];

                    return {
                        nombre: nombres_input,
                        apellido: apellido,
                        apellido2: apellido2
                    };
                }
            }
        }

        if (herencia_padre_array.length === 0 && herencia_madre_array.length === 0) {
            const division_nombres: string[] = nombre.split(" ");
            var nombres_input: string = ""
            var apellido: string
            var apellido2: string

            if (division_nombres.length === 4) {
                division_nombres.slice(2, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
            else if (division_nombres.length === 5) {
                division_nombres.slice(3, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1] + " " + division_nombres[2];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
        }

        var herencia_padre: any[] = [];
        var herencia_madre: any[] = [];

        //Obtenemos el primer apellido
        var primer_apellido = "";
        if (herencia_padre_array.length > 0) {
            primer_apellido = padre_list[0];
        }
        else {
            primer_apellido = madre_list[0];
        }

        //APELLIDOS NOMBRES
        if (nombre.indexOf(primer_apellido) === 0) {
            var i_tmp = 0;
            //Limpiamos la herencia del padre
            herencia_padre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (padre_list.indexOf(herencia_padre_array[i]) === i_tmp) {
                    herencia_padre.push(herencia_padre_array[i]);
                    i_tmp++;
                }
            }

            //Limpiamos la herencia del madre
            var i_tmp = 0;
            herencia_madre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (madre_list.indexOf(herencia_madre_array[i]) === i_tmp) {
                    herencia_madre.push(herencia_madre_array[i]);
                    i_tmp++;
                }
            }
        }
        else {
            //Limpiamos la herencia del padre
            herencia_padre = [];
            var pos_ap = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (nombres_list.indexOf(herencia_padre_array[i]) === pos_ap) {
                    herencia_padre.push(herencia_padre_array[i]);
                    pos_ap++;
                }
            }

            //Limpiamos la herencia del madre
            herencia_madre = [];
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (nombres_list.indexOf(herencia_madre_array[i]) === pos_ap) {
                    herencia_madre.push(herencia_madre_array[i]);
                    pos_ap++;
                }
            }
        }

        herencia_padre.forEach(i_padre => {
            apellido_padre += i_padre + " ";
        }
        );

        apellido_padre = apellido_padre.trim();

        //Obtenemos el apellido de la madre
        herencia_madre.forEach(i_madre => {
            apellido_madre += i_madre + " ";
        }
        );

        apellido_madre = apellido_madre.trim();

        try {
            if (apellido_padre != "") {
                nombres = nombre.trim().replace(apellido_padre, "");
            }
            else {
                nombres = nombre;
            }

            if (apellido_madre != "") {
                nombres = nombres.replace(apellido_madre, "");
            }
            nombres = nombres.trim();
        }
        catch
        {
            nombres = "";
            apellido_padre = "";
            apellido_madre = "";
        }

        return {
            nombre: nombres,
            apellido: apellido_padre,
            apellido2: apellido_madre
        };
    }

    function buscarPersona(numeroidentificacion) {
        setIsLoadingData(true); // Activar indicador de carga
        if (tipoidentificacion === "CED" && numeroidentificacion && numeroidentificacion.length === 10) {
            fetch(API_URL + "DatosGenerales/Ciudadano/" + numeroidentificacion)
                .then(res => res.json())
                .then(
                    (result) => {
                        setIsLoadingData(false); // Desactivar indicador de carga
                        if (result.strEstado === "S") {
                            if (result.entTabla[0].nombre) {
                                //console.log(result.entTabla[0].error)
                                if (result.entTabla[0].nombrePadre && result.entTabla[0].nombreMadre && result.entTabla[0].nombre) {
                                    //console.log("entra")
                                    const { nombre, apellido, apellido2 } = getNombresCompletos(result.entTabla[0].nombrePadre, result.entTabla[0].nombreMadre, result.entTabla[0].nombre);
                                    setNombres(nombre)
                                    setApellidos(apellido + " " + apellido2)
                                }
                                if (result.entTabla[0].fechaNacimiento) {
                                    var info = result.entTabla[0].fechaNacimiento.split('/');
                                    var date = info[0] + "/" + info[1] + "/" + info[2]
                                    setFechaNacimiento(date)
                                }
                                setSexo(result.entTabla[0].sexo === "MUJER" ? "F" : "M")
                                setParentesco("Hijo/a")
                            }
                        } else {
                            setError("Ocurrió un error al obtener información del ciudadano.")
                        }
                    },
                    (error) => {
                        setIsLoadingData(false); // Desactivar indicador de carga en caso de error
                        setError("Ocurrió un error: " + error)
                    }
                )
        } else {
            setIsLoadingData(false); // Desactivar si no cumple condiciones
        }
    }

    function ValidarInfante(numeroidentificacion) {
        setIsLoadingData(true); // Activar indicador de carga
        if (tipoidentificacion === "CED" && numeroidentificacion && numeroidentificacion.length === 10) {
            fetch(API_URL + "SolicitudCambioHorarioPRN/ValidarInfanteRegistrado/" + numeroidentificacion)
                .then(res => res.json())
                .then(
                    (result) => {
                        setIsLoadingData(false); // Desactivar indicador de carga
                        console.log(result)
                        if (result.mensaje !== "") {
                            setError(result.mensaje)
                        } else {
                            setError(result.mensaje)
                        }
                        /*if (result.strEstado === "S") {
                            if (result.entTabla[0].nombre) {
                                //console.log(result.entTabla[0].error)
                                if (result.entTabla[0].nombrePadre && result.entTabla[0].nombreMadre && result.entTabla[0].nombre) {
                                    //console.log("entra")
                                    const { nombre, apellido, apellido2 } = getNombresCompletos(result.entTabla[0].nombrePadre, result.entTabla[0].nombreMadre, result.entTabla[0].nombre);
                                    setNombres(nombre)
                                    setApellidos(apellido + " " + apellido2)
                                }
                                if (result.entTabla[0].fechaNacimiento) {
                                    var info = result.entTabla[0].fechaNacimiento.split('/');
                                    var date = info[0] + "/" + info[1] + "/" + info[2]
                                    setFechaNacimiento(date)
                                }
                                setSexo(result.entTabla[0].sexo === "MUJER" ? "F" : "M")
                                setParentesco("Hijo/a")
                            }
                        } else {
                            setError("Ocurrió un error al obtener información del ciudadano.")
                        }*/
                    },
                    (error) => {
                        setIsLoadingData(false); // Desactivar indicador de carga
                        console.log(error)
                        setError("Ocurrió un error: " + error)
                    }
                )
        } else {
            setIsLoadingData(false); // Desactivar si no cumple condiciones
        }
    }
    
    // Manejar cambio de número de identificación
    const handleNumeroIdentificacionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // Solo permitir números si es cédula
        if (tipoidentificacion === "CED" && !/^\d*$/.test(value)) {
            return;
        }

        setNumeroIdentificacion(value);
        limpiarDatosInfante(); // Limpiar datos anteriores

        // Validar solo si es cédula y tiene 10 dígitos
        if (tipoidentificacion === "CED" && value.length === 10) {
            buscarPersona(value);
            ValidarInfante(value);
        }
    };

    // Modificamos la función para cerrar el modal
    const handleCloseModal = () => {
        // Si es nacimiento múltiple y menos de 2 registros, no permitir cerrar
        if (subtipoMaternidad === "NACIMIENTO MÚLTIPLE" && registrosRealizados < 2) {
            setError("Debe registrar al menos dos infantes para nacimiento múltiple");
            return;
        }

        limpiarFormulario();
        setRegistrosRealizados(0); // Resetear contador al cerrar
        toggleRegistrarInfante();
        if (onClose) onClose(); // Notificamos al padre que el modal se cerró
    };

    const handleSaveRegistrarInfante = async () => {
        // Validación básica de campos obligatorios
        if (!tipoidentificacion || !numeroidentificacion || !nombres || !apellidos || !fechaNacimiento || !sexo || !parentesco || !usoGuarderia) {
            setError("Todos los campos son obligatorios");
            return;
        }

        if (tipoidentificacion === "CED" && numeroidentificacion.length !== 10) {
            setError("La cédula debe tener 10 dígitos");
            return;
        }

        setIsLoading(true);
        setError("");
        setSuccessMessage("");

        try {            
            // Formatear fecha si es necesario (ejemplo: convertir de DD/MM/YYYY a YYYY-MM-DD)
            const formattedFechaNacimiento = fechaNacimiento.split('/').reverse().join('-');

            const data = {
                tipoidentificacion,
                numeroidentificacion,
                nombres: nombres.trim(),
                apellidos: apellidos.trim(),
                fechaNacimiento: formattedFechaNacimiento,
                sexo,
                parentesco,
                usoGuarderia
            };

            console.log("Datos a enviar:", data); // Para depuración

            const response = await fetch(API_URL + "SolicitudCambioHorarioPRN/RegistrarInfante", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (result.strEstado === "S") {
                setSuccessMessage(result.mensaje);
                setRegistrosRealizados(prev => prev + 1); // Incrementar contador
                limpiarFormulario();
                // No cerramos el modal automáticamente
            } else {
                setError(result.mensaje || "Error al registrar el infante");
            }
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            setError("Ocurrió un error al conectar con el servidor");
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const renderAlert = (
        message: string,
        type: 'danger' | 'success',
        onDismiss: () => void
    ) => {
        if (!message) return null;

        return (
            <Alert
                color={type}
                toggle={onDismiss}
                className="mt-3"
                style={{
                    padding: '0.5rem 1rem' // Hace más compacta la alerta
                }}
            >
                {message}
                <style>{`.alert-dismissible .close {
                    font-size: 1rem;       /* Reduce el tamaño de la X */
                    padding: 0.25rem 0.5rem; /* Reduce el espacio alrededor */
                }`}</style>
            </Alert>
        );
    };

    return (
        <Modal isOpen={isOpenRegistrarInfante} toggle={handleCloseModal} centered size="xl">
            <ModalHeader toggle={handleCloseModal} className="text-center w-100 mdl-encabezado">REGISTRAR INFANTE</ModalHeader>
            <ModalBody>
                {subtipoMaternidad === "NACIMIENTO MÚLTIPLE" && registrosRealizados < 2 && (
                    <Alert color="info" className="mb-3">
                        <i className="fas fa-info-circle mr-2"></i>
                        Para nacimiento múltiple debe registrar al menos 2 infantes ({registrosRealizados}/2 registrados)
                    </Alert>
                )}

                {renderAlert(error, 'danger', () => setError(""))}
                {renderAlert(successMessage, 'success', () => setSuccessMessage(""))}

                <FormGroup row>
                    <Col md={6}>
                        <Label for="tipoidentificacion">Tipo de documento: </Label>
                        <SelectItem2
                            options={tiposIdentificacion}
                            value={tipoidentificacion}
                            onChange={handleTipoIdentificacionChange} // Usamos la nueva función
                            placeholder=""
                            name="tipoidentificacion"
                            id="tipoidentificacion"
                            icon="fa-caret-down"
                        />
                    </Col>
                    <Col md={6}>
                        <Label for="numeroidentificacion">Número de documento identidad:</Label>
                        <div style={{ position: 'relative' }}>
                            <Input
                                type={tipoidentificacion === "CED" ? "number" : "text"} // Cambia el tipo según el documento
                                maxLength={tipoidentificacion === "CED" ? 10 : undefined}
                                name="numeroidentificacion"
                                id="numeroidentificacion"
                                value={numeroidentificacion}
                                onChange={handleNumeroIdentificacionChange}
                                required
                                disabled={!tipoidentificacion} // Deshabilitar si no hay tipo seleccionado
                            />
                            {isLoadingData && (
                                <div style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}>
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}
                        </div>
                        {isLoadingData && (
                            <small className="text-muted">Buscando información...</small>
                        )}
                    </Col>
                </FormGroup>               
                
                <FormGroup row>
                    <Col md={6}>
                        <Label for="nombres">Nombres: </Label>
                        <Input type="text" value={nombres} readOnly />
                    </Col>
                    <Col md={6}>
                        <Label for="apellidos">Apellidos: </Label>
                        <Input type="text" id="apellidos" value={apellidos} readOnly/>
                    </Col>
                </FormGroup>
                
                <FormGroup row>
                    <Col md={6}>
                        <Label for="fechaNacimiento">Fecha Nacimiento: </Label>
                        <Input type="text" id="fechaNacimiento" value={fechaNacimiento} readOnly/>
                    </Col>
                    <Col md={6}>
                        <Label for="sexo">Sexo: </Label>
                        <Input type="text" id="sexo" value={sexo} readOnly />
                    </Col>
                </FormGroup>
                
                <FormGroup row>
                    <Col md={6}>
                        <Label for="parentesco">Parentesco: </Label>
                        <Input type="text" id="parentesco" value={parentesco} readOnly/>
                    </Col>
                    <Col md={6}>
                        <Label for="usoGuarderia">¿Desea hacer uso de la guardería?: </Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="usoGuarderia"
                                        value="S"
                                        checked={usoGuarderia === "S"}
                                        onChange={(e) => setUsoGuarderia(e.target.value)}
                                    />{' '}
                                    Sí
                                </Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="usoGuarderia"
                                        value="N"
                                        checked={usoGuarderia === "N"}
                                        onChange={(e) => setUsoGuarderia(e.target.value)}
                                    />{' '}
                                    No
                                </Label>
                            </FormGroup>
                        </div>
                    </Col>
                </FormGroup>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
                <Button className="btn-cancelar-new" onClick={handleCloseModal}>
                    CANCELAR
                </Button>
                <Button 
                    color="secondary" 
                    onClick={handleSaveRegistrarInfante} 
                    disabled={error !== "" || isLoading || !numeroidentificacion || !tipoidentificacion}
                >
                    {isLoading ? "PROCESANDO..." : "CONFIRMAR"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
